<template>
  <div class="services-sidebar">
    <BuyNumberModal
        :buy-number-modal-is-open="buyNumberModalIsOpen"
        :is-chinese-language="isChineseLanguage"
        :service-route="serviceRoute"
        :service-route-slug="serviceRouteSlug"
        @close="buyNumberModalIsOpen = false"
    />

    <BlockNumberModal
        :block-modal-is-open="blockModalIsOpen"
        :block-modal-banned-to="blockModalBannedTo"
        @close="blockModalIsOpen = false"
    />

    <ServiceSelectorTabs
        :numbers-selected="numbersSelected"
        :mails-selected="mailsSelected"
        @select-numbers="selectNumbers"
        @select-mails="selectMails"
    />

    <ServiceSidebarSection
        :placeholder-services="placeholderServices"
        :selected-service="selectedService"
        :is-focus-search-service="isFocusSearchService"
        :is-mounted="isMounted"
        :popular-count="popularCount"
        :search-services-list-wrapper="searchServicesListWrapper"
        :search-services-list="searchServicesList"
        :is-russian-language="isRussianLanguage"
        @search-services="searchServicesFunc"
        @select-service="changeSelectedService"
        @focus-search="changeFocusSearchService"
    />

    <Notification
        :is-mail-selected="mailsSelected"
    />

    <CountryList
        :selected-service="selectedService"
        :individual-prices="individualPrices.numbers"
        :numbers-selected="numbersSelected"
        :service-countries="serviceCountries"
        :search-countries-list="searchCountriesList"
        :is-mounted="isMounted"
        :rows-country="rowsCountry"
        :selected-country-id="selectedCountryId"
        :open-counties="openCounties"
        :sort-by-price-option="sortByPriceOption"
        :sort-by-quantity-option="sortByQuantityOption"
        :sort-by-top-option="sortByTopOption"
        :active-filter="activeFilter"
        @toggle-country="changeOpenCounties"
        @buy-number="buyPhoneNumber"
        @sort-position="sortPosition"
    />

    <MailDomainList
        :individual-prices="individualPrices.mails"
        :numbers-selected="numbersSelected"
        :mail-domains="mailDomains"
        :search-mail-domains-list="searchMailDomainsList"
        :is-mounted="isMounted"
        :rows-country="rowsCountry"
        :sort-by-price-option="sortByPriceOption"
        :sort-by-quantity-option="sortByQuantityOption"
        :active-filter="activeFilter"
        @buy-mail="buyMail"
    />

    <div class="buy-mail-via-txt-wrapper" v-if="typeServices === 'mailsServices'" @click="buyBatchMailPage">
      <button class="button order-via-txt" v-html="getLocalization('Order Emailʼs with txt')">
      </button>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import BaseAdminMixin from "../../admin/components/mixins/BaseAdminMixin.vue";
import Modal from "../../components/table/modalNew.vue";

import BuyNumberModal from "./vitrineComponents/buyNumberModal.vue"
import BlockNumberModal from "./vitrineComponents/blockNumberModal.vue"
import ServiceSelectorTabs from "./vitrineComponents/serviceSelectorTabs.vue"
import ServiceSidebarSection from "./vitrineComponents/serviceSidebarSection.vue"
import CountryList from "./vitrineComponents/countryList.vue"
import MailDomainList from "./vitrineComponents/mailDomainList.vue";
import Notification from "./vitrineComponents/notification.vue";

import {methods} from "./vitrineComponents/data/methods"
import {computed} from "./vitrineComponents/data/computed"

export default {
  name: "buyNumber",
  mixins: [
    BaseAdminMixin
  ],
  components: {
    Modal,
    Multiselect,

    BuyNumberModal,
    BlockNumberModal,
    ServiceSelectorTabs,
    ServiceSidebarSection,
    CountryList,
    MailDomainList,
    Notification,
  },
  props: [
    'user',
    'registrationRoute',
    'topUpRoute',
    'phoneHistoryRoute',
    'mailHistoryRoute',
    'popularCount',
    'rowsCountry',
    'serviceRoute',
    'buyBatchMailRoute'
  ],
  data: function () {
    return {
      windowWidth: 0,
      selectedService: {
        activate_org_code: "tg",
        id: 5,
        title: "Telegram"
      },
      allData: {
        byServices: null,
        byMails: null
      },
      popularServices: [],
      popularMailServices: [],
      isMounted: false,
      selectedCountryId: null,
      sortByQuantityOption: 1,
      sortByPriceOption: 1,
      sortByTopOption: 1,
      services: [],
      searchServices: '',
      searchCountries: '',
      searchDomains: '',
      isFocusSearchService: false,
      serviceCountries: [],
      filteredServiceCountries: [],
      openCounties: [],
      isMoreCounties: false,
      isOpenFilter: false,
      activeFilter: 3,
      selected: true,
      numbersSelected: true,
      mailsSelected: false,
      mailDomains: [],
      mailsServices: [],
      typeServices: 'services',
      updateRestsIntervalId: null,
      selectedServiceKey: 'selectedService',
      maxWaitTime: 300000, // 5 min
      startBuyNumberTime: 0,
      buyNumberModalIsOpen: false,
      serviceRouteSlug: 'telegram',
      banPositions: [],
      blockModalIsOpen: false,
      blockModalBannedTo: '',
      isMountedForVitrineProcessor: false,
      individualPrices: {
        numbers: {},
        mails: {},
      },
    }
  },
  async beforeMount() {
    this.$nextTick(() => {
      this.clearVueApp();
    });

    await this.processVitrine();

    this.$root.$on('emit-buy-phone-number', async (maxPrice, countryCode, serviceCode, providerIds = null) => {
      await this.buyPhoneNumber(maxPrice, countryCode, serviceCode, providerIds);
    });
  },
  async mounted() {
    setInterval(async () => {
      await this.clearSessionStorage();
    }, 600000); // 10 мин

    this.handleResize();

    await this.getIndividualPrices();

    if (sessionStorage.getItem('isMailSelected') || window.location.hash === '#mail') {
      await this.selectMails();
    } else {
      await this.selectNumbers(true);
    }

    this.handlePrevSelectedService();
    this.isMounted = true;

    this.updateRestsIntervalId = setInterval(() => this.loadData(), 30000);
  },
  computed: computed,
  methods: methods
}
</script>
